// Central configuration file for the DriverWatch portal
// Change API_URL here to switch between local development and Azure production
// Local development:  http://127.0.0.1:8000
// Azure production:   https://driverwatch-api.azurewebsites.net

const config = { API_URL: "https://driverwatch-api.azurewebsites.net" };

export default config;